/* eslint-disable max-len */
import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as types from "~/store/news/newsType";
import * as api from "~/store/news/newsApi";
import { ceil } from "lodash-es";
import { apiNews, LIMIT_PAGE_NEWS } from "~/utils/constants";

function* getTotalListNews() {
  try {
    const url = apiNews + `/posts?&categories.slug=tin-tuc`;
    const rs = yield call(api.countData, url);
    const sumPage = ceil(rs / LIMIT_PAGE_NEWS);

    yield put({ type: types.COUNT_LIST_NEWS_SUCCESS, totalData: sumPage });
  } catch (error) {
    console.log("error :>> ", error);
  }
}
function* watchGetTotalListNews() {
  yield takeLatest(types.GET_TOTAL_LIST_NEWS, getTotalListNews);
}

function* getListNews({ page = 1 }) {
  try {
    const start = +page === 1 ? 0 : (+page - 1) * LIMIT_PAGE_NEWS;
    const url =
      apiNews +
      `/posts?&categories.slug=tin-tuc&_start=${start}&_limit=${LIMIT_PAGE_NEWS}&_sort=updated_at:desc`;

    const rs = yield call(api.getData, url);

    yield put({ type: types.LIST_NEWS_SUCCESS, listNews: rs });
  } catch (error) {
    console.log("error :>> ", error);
  }
}
function* watchGetListNews() {
  yield takeLatest(types.GET_LIST_NEWS, getListNews);
}

function* getGetListNewsBanner() {
  try {
    const url = `https://cms.medpro.com.vn/posts?_sort=updated_at:DESC`;

    const rs = yield call(api.getListNewsBanner, url);

    yield put({ type: types.LIST_NEWS_BANNERS_SUCCESS, listNewsBanner: rs });
  } catch (error) {
    console.log("error :>> ", error);
  }
}
function* watchGetListNewsBanner() {
  yield takeLatest(types.LIST_NEWS_BANNERS, getGetListNewsBanner);
}

export default function* root() {
  yield all([
    fork(watchGetTotalListNews),
    fork(watchGetListNews),
    fork(watchGetListNewsBanner)
  ]);
}
